import { render, staticRenderFns } from "./RolePermissionsTable.vue?vue&type=template&id=b4ec71f6"
import script from "./RolePermissionsTable.vue?vue&type=script&lang=js"
export * from "./RolePermissionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4ec71f6')) {
      api.createRecord('b4ec71f6', component.options)
    } else {
      api.reload('b4ec71f6', component.options)
    }
    module.hot.accept("./RolePermissionsTable.vue?vue&type=template&id=b4ec71f6", function () {
      api.rerender('b4ec71f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/RolePermissions/RolePermissionsTable.vue"
export default component.exports